<template>
  <b-row v-if="estado && tipos" class="fila-disponibilidad">
    <b-col cols="1" class="hora-label">
      <span class="hora-text">{{ hora.nombre_corto }}</span>
    </b-col>
    <b-col class="celda" v-for="(tipo, t_index) in tipos" :key="t_index">
      <div 
        class="celda-content" 
        :style="{ backgroundColor: variant(estado[tipo.id]) }" 
        v-if="estado[tipo.id]"
        :title="'Ocupación: ' + estado[tipo.id].porcentaje_ocupacion + '%'"
      >
        <div class="celda-capacidad">{{ estado[tipo.id].ocupacion_total }}/{{ estado[tipo.id].capacidad_total }}</div>
        <div class="celda-porcentaje">{{ estado[tipo.id].porcentaje_ocupacion }}%</div>
      </div>
      <div class="celda-content celda-vacia" v-else>
        <span class="celda-sin-datos">—</span>
      </div>
    </b-col>
    <b-col class="celda celda-total" v-if="indicadoresFranja">
      <div class="celda-content celda-total-franja">
        <div class="celda-capacidad-total">{{estado.total_ocupacion}}/{{ estado.total_capacidad }}</div>
        <div class="celda-porcentaje-total">{{ estado.porcentaje_ocupacion }}%</div>
      </div>
    </b-col>
    <b-col class="celda celda-total" v-if="indicadoresFranja">
      <div class="celda-content celda-docentes-libres" title="Docentes libres">
        <div class="celda-capacidad-total">{{ estado.libres }}</div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Vue from 'vue';
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/sync-alt'

export default {
  name: 'DashboardDisponibilidadFranja',
  components: {
    Icon

  },
  data() {
    return {
      updateTime: null,
    }
  },
  props: {
    dia: Object,
    hora: Object,
  },
  mounted() {
    this.procesarActualizar()
  },
  methods: {
    ...mapActions({
      fetchDisponibilidad: 'estado/fetchDisponibilidadNuevo',
    }),
    ...mapMutations({
    }),
    procesarActualizar() {
      this.fetchDisponibilidad({ dia: this.dia.fecha, hora: this.hora.hora })
    },
    capacidad(estado) {
      return estado.capacidad_salones_disponibles + estado.capacidad_salones_ocupados
    },
    variant(estado) {
      if (estado) {
        if(estado.porcentaje_ocupacion == 0 && estado.capacidad_total == 0){
          return '#e5e7eb'; // Gris claro (vacío)
        } else if(estado.porcentaje_ocupacion <= 50){
          return '#9ca3af'; // Gris
        } else if(estado.porcentaje_ocupacion <= 70){
          return '#fbbf24'; // Amarillo
        } else if(estado.porcentaje_ocupacion <= 90){
          return '#10b981'; // Verde
        } else {
          return '#ef4444'; // Rojo
        }
      }
      return '#e5e7eb'; // Gris claro para sin datos
    }

  },
  computed: {
    ...mapState({
      tiposNuevos: state => state.asw.tiposNuevaDisponibilidad,
      disponibilidad: state => state.estado.disponibilidad,
      user: state => state.auth.user,
    }),
    tipos(){
      // Si es sede presencial
      if(this.user && this.user.data.sede_id != 30){
        const excludedTypesPresencial = ['SUA', 'SUB', 'clase_0', 'lab']
        return this.tiposNuevos.filter(tipo => !excludedTypesPresencial.includes(tipo.id))
      }else{
        return this.tiposNuevos.filter(tipo => tipo.id != 'SU')
      }
    },
    ...mapGetters({
      getDisponibilidadXFranja: 'estado/getDisponibilidadXFranja',
    }),
    updateTimeFormated() {
      if (this.updateTime) {
        return this.updateTime.toLocaleString('es-CO', { timeZone: "America/Bogota" })
      }
      return null
    },
    estado() {
      if (this.dia && this.hora && this.hora.hora) {
        let key = this.user.data.sede_id + ':' + this.dia.fecha + ':' + this.hora.hora
        if (this.disponibilidad[key]) {
          let respuesta = this.disponibilidad[key]
          return respuesta
        }
        return false
      }
      return false

    },
    indicadoresFranja() {
      if (this.estado) {
        let o = this.estado.ocupacion_salones_ocupados_franja
        let cs = this.estado.capacidad_salones_ocupados_franja
        let cd = this.estado.capacidad_docentes_disponibles_franja
        let ct = cs + cd
        let r = ct > 0 ? (o / ct * 100) : 0
        r = Math.round(r)
        return o + '/' + ct + ' (' + r + '%)'
      }
      return false
    }


  }
}
</script>

<style scoped>
.fila-disponibilidad {
  margin: 0;
  transition: all 0.2s ease;
}

.fila-disponibilidad:hover {
  background-color: #f9fafb;
  border-radius: 4px;
}

.hora-label {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 4px 6px !important;
}

.hora-text {
  font-size: 18px;
  font-weight: 600;
  color: #4b5563;
  letter-spacing: 0.025em;
}

.celda {
  padding: 2px !important;
  margin: 0;
}

.celda-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
  cursor: pointer;
  min-height: 40px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  gap: 2px;
}

.celda-content:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
  border-color: white;
}

.celda-capacidad, .celda-capacidad-total {
  font-size: 0.95rem;
  font-weight: 700;
  color: white;
  line-height: 1;
  white-space: nowrap;
}

.celda-porcentaje {
  font-size: 0.7rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  padding: 1px 6px;
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  line-height: 1.2;
}

.celda-porcentaje-total {
  font-size: 0.75rem;
  font-weight: 700;
  color: white;
  padding: 2px 8px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  line-height: 1.2;
}

.celda-vacia {
  background-color: #f3f4f6;
  border: 1px dashed #d1d5db;
}

.celda-sin-datos {
  font-size: 1rem;
  color: #9ca3af;
}

.celda-total-franja {
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
  border: 1px solid #1f2937;
}

.celda-docentes-libres {
  background: #ffffff;
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

.celda-docentes-libres .celda-capacidad-total {
  color: #111827;
}



@media (max-width: 768px) {
  .fila-disponibilidad {
    width: 900px;
    min-width: 900px;
  }

  .celda-content {
    padding: 5px 3px;
    min-height: 38px;
  }

  .celda-capacidad, .celda-capacidad-total {
    font-size: 14px;
  }

  .celda-porcentaje {
    font-size: 0.65rem;
    padding: 1px 4px;
  }

  .hora-text {
    font-size: 0.7rem;
  }

  .celda-porcentaje-total {
    font-size: 0.7rem;
    padding: 1px 6px;
  }

  .celda-total {
    flex: 1.35 0 0 !important;
  }
}
</style>